import React from "react";
import {
    Text,
    View,
    Image
} from "@react-pdf/renderer";
import { styles } from "./../ExportToPDFStyles";

const getSignatureSource = (signature) => (
    typeof signature === 'object' && signature !== null ? signature.source : signature
);

const getSignatureStyle = (signature) => {
    const scale = typeof signature === 'object' && signature !== null
        ? signature.scale || 100
        : 100;

    return {
        width: `${92 * scale / 100}%`,
        height: 42 * scale / 100,
    };
};

const allowsOverflow = (signature) => (
    typeof signature === 'object' && signature !== null && signature.allowOverflow === true
);


const ResponsaveisLaudo = ({
    textCabecalhoInspetor,
    textCabecalhoResponsavelTecnico,
    textCabecalhoResponsavelLaudo,
    textNomeInspetor,
    nomeInspetor,
    textNomeResponsavelLaudo,
    nomeResponsavelLaudo,
    textNomeResponsavelTecnico,
    nomeResponsavelTecnico,
    textNumeroDocumento,
    numeroDocumentoInspetor,
    numeroDocumentoRespLaudo,
    textCrea,
    crea,
    assinaturaInspetorImage,
    assinaturaResponsavelImage,
    assinaturaResponsavelLaudoImage,
}) => (
    <>
        <View style={[styles.rectangleTitle, { marginTop: 8 }]}>
            <Text style={styles.numberText}>7.</Text>
            <View style={[styles.verticalLine]}></View>

            <Text style={{ fontSize: 9, fontFamily: "Arial", fontWeight: "bold", width: '33%', textAlign: "center" }}>
                {textCabecalhoInspetor}
            </Text>
            <View style={[styles.verticalLine, {marginRight: 13.9}]}></View>
            <Text style={{ fontSize: 9, fontFamily: "Arial", fontWeight: "bold", width: '33%', textAlign: "center" }}>
                {textCabecalhoResponsavelLaudo}
            </Text>
            <View style={[styles.verticalLine, {marginRight: 13.9}]}></View>
            <Text style={{ fontSize: 9, fontFamily: "Arial", fontWeight: "bold", width: '33%', textAlign: "center" }}>
                {textCabecalhoResponsavelTecnico}
            </Text>
        </View>

        <View style={styles.rectangle}>
            <Text style={[styles.textSection, { width: '33.333%' }]}>
                {textNomeInspetor}
                {nomeInspetor}
            </Text>
            <View style={[styles.verticalLine]}></View>
            <Text style={[styles.textSection, { width: '33.333%' }]}>
                {textNomeResponsavelLaudo}
                {nomeResponsavelLaudo}
            </Text>
            <View style={[styles.verticalLine]}></View>
            <Text style={[styles.textSection, { width: '33.333%' }]}>
                {textNomeResponsavelTecnico}
                {nomeResponsavelTecnico}
            </Text>
        </View>

        <View style={styles.rectangle}>
            <Text style={[styles.textSection, { width: '33.333%' }]}>
                {textNumeroDocumento}
                {numeroDocumentoInspetor}
            </Text>
            <View style={[styles.verticalLine]}></View>
            <Text style={[styles.textSection, { width: '33.333%' }]}>
                {textNumeroDocumento}
                {numeroDocumentoRespLaudo}
            </Text>
            <View style={[styles.verticalLine]}></View>
            <Text style={[styles.textSection, { width: '33.333%' }]}>
                {textCrea}
                {crea}
            </Text>

        </View>

        <View style={[styles.rectangle, { minHeight: 47, borderTop: 0 }]}>
            <View style={{
                borderWidth: 1.5,
                borderColor: '#000',
                borderTop: 0,
                borderLeft: 0,
                borderBottom: 0,
                borderRight: 0,
                width: '33.333%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 1,
                overflow: allowsOverflow(assinaturaInspetorImage) ? 'visible' : 'hidden'
            }}>
                <Image
                    source={getSignatureSource(assinaturaInspetorImage)}
                    resizeMode="contain"
                    style={getSignatureStyle(assinaturaInspetorImage)}
                />
            </View>
            <View style={[styles.verticalLine]}></View>
            <View style={{
                borderWidth: 1.5,
                borderColor: '#000',
                borderTop: 0,
                borderLeft: 0,
                borderBottom: 0,
                borderRight: 0,
                width: '33.333%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 1,
                overflow: allowsOverflow(assinaturaResponsavelLaudoImage) ? 'visible' : 'hidden'
            }}>
                <Image
                    source={getSignatureSource(assinaturaResponsavelLaudoImage)}
                    resizeMode="contain"
                    style={getSignatureStyle(assinaturaResponsavelLaudoImage)}
                />
            </View>

            <View style={[styles.verticalLine]}></View>
            <View style={{
                borderWidth: 1.5,
                borderColor: '#000',
                borderTop: 0,
                borderLeft: 0,
                borderBottom: 0,
                borderRight: 0,
                width: '33.333%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 1,
                overflow: allowsOverflow(assinaturaResponsavelImage) ? 'visible' : 'hidden'
            }}>
                <Image
                    source={getSignatureSource(assinaturaResponsavelImage)}
                    resizeMode="contain"
                    style={getSignatureStyle(assinaturaResponsavelImage)}
                />
            </View>
        </View>
    </>
);
export default ResponsaveisLaudo;
